import { render, staticRenderFns } from "./water-num.vue?vue&type=template&id=6be9dd4d&scoped=true&"
import script from "./water-num.vue?vue&type=script&lang=js&"
export * from "./water-num.vue?vue&type=script&lang=js&"
import style0 from "./water-num.vue?vue&type=style&index=0&id=6be9dd4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be9dd4d",
  null
  
)

export default component.exports